export enum OpsEventBlocEnum {
  event = 'event',
  trackedLink = 'trackedLink',
}
